export const name = "LEFT";
export const summary = `Gets the specified leftmost portion from a \`STRING\` or \`BYTES\` value.`;
export const reference = `
## LEFT

Gets the specified leftmost portion from a \`STRING\` or \`BYTES\` value.

\`\`\`
LEFT(value, length)
\`\`\`

### Description

Returns a \`STRING\` or \`BYTES\` value that consists of the specified number of leftmost characters or bytes from \`value\`. The \`length\` is an\`INT64\` that specifies the length of the returned value. If \`value\` is of type \`BYTES\`, \`length\` is the number of leftmost bytes to return. If \`value\` is \`STRING\`, \`length\` is the number of leftmost characters to return.

If \`length\` is 0, an empty \`STRING\` or \`BYTES\` value will be returned. If \`length\` is negative, an error will be returned. If \`length\`exceeds the number of characters or bytes from \`value\`, the original \`value\`will be returned.


### Return type

\`STRING\` or \`BYTES\`


### Examples



\`\`\`
SELECT LEFT('banana', 3) AS results

/*---------*
 | results |
  +--------+
 | ban |
 *---------*/
\`\`\`



\`\`\`
SELECT LEFT(b'\\xab\\xcd\\xef\\xaa\\xbb', 3) AS results

-- Note that the result of LEFT is of type BYTES, displayed as a base64-encoded string.
/*---------*
 | results |
 +---------+
 | q83v |
 *---------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/string_functions
`;
